interface FollowSelectorEmptyProps {
    message?: string;
    isSearching?: boolean;
}

/**
 * Empty state shown when there are no items to display.
 */
export const FollowSelectorEmpty = ({
    message,
    isSearching = false,
}: FollowSelectorEmptyProps) => {
    const defaultMessage = isSearching
        ? 'No boards found matching your search'
        : 'No boards yet. Create one to get started!';

    return (
        <div className="flex flex-col items-center justify-center py-8 text-center">
            <p className="text-sm text-gray-500">{message || defaultMessage}</p>
        </div>
    );
};
